const log = require('log').create('hasSignature') // eslint-disable-line

const { ONE_YEAR } = require('lib/time')

module.exports = function hasSignature(user) {
    // returns true if user has a signature viewed in the last year
    const signature_viewed = user.flags && user.flags.email_signature_last_viewed || 0
    const last_viewed_period = Date.now() - signature_viewed
    if (last_viewed_period < ONE_YEAR) return true
    return false
}
